import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Table,
  Button
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import config from "../../config/config";

import "./trendingcategory.scss";

function TrendingCategoryList() {
  const navigate = useNavigate();
  const [trendingCategories, setTrendingCategories] = React.useState([]);
  const [hoveredRow, setHoveredRow] = React.useState(null);
  const breadcrumbItems = [
    { title: "Trending Categories", link: "#" },
    { title: "Trending Category List", link: "#" },
  ];

  React.useEffect(() => {
    fetchTrendingCategories();
  }, []);

  const fetchTrendingCategories = async () => {
    try {
      const response = await fetch(`${config.API_BASE_URL}/trending-categories`);
      const data = await response.json();
      console.log('Trending Categories data:', data);
      setTrendingCategories(data.data || data);
    } catch (error) {
      console.error('Error fetching trending categories:', error);
    }
  };

  const handleEdit = (trendingCategory) => {
    navigate(`/edit-trending-category/${trendingCategory._id}`, { state: { trendingCategory } });
  };

  const handleDelete = async (trendingCategoryId) => {
    if (window.confirm("Are you sure you want to delete this trending category?")) {
      try {
        const response = await fetch(`${config.API_BASE_URL}/trending-categories/${trendingCategoryId}`, {
          method: 'DELETE'
        });
        
        if (response.ok) {
          setTrendingCategories(trendingCategories.filter(tc => tc._id !== trendingCategoryId));
        } else {
          console.error('Failed to delete trending category');
        }
      } catch (error) {
        console.error('Error deleting trending category:', error);
      }
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Trending Category List"
            breadcrumbItems={breadcrumbItems}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-end mb-4">
                    <Link to="/create-trending-category">
                      <Button color="primary">
                        <i className="ri-add-line align-middle me-1"></i> Add Trending Category
                      </Button>
                    </Link>
                  </div>
                  <div className="table-responsive">
                    <Table className="table table-centered table-nowrap mb-0">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Name</th>
                          <th>Image</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {trendingCategories.map((trendingCategory, index) => (
                          <tr 
                            key={trendingCategory._id}
                            className="trending-category-row"
                          >
                            <td>{trendingCategory._id}</td>
                            <td>{trendingCategory.name}</td>
                            <td>
                              <img
                                src={`${config.IMAGE_URL}/${trendingCategory.image}`}
                                alt={trendingCategory.name}
                                width="50"
                                height="50"
                                className="rounded"
                              />
                            </td>
                            <td>
                              <span className="badge bg-success">
                                Active
                              </span>
                            </td>
                            <td>
                                <button 
                                  className="trending-category-action-buttons"
                                  onClick={() => handleEdit(trendingCategory)}
                                >
                                  <i className="ri-pencil-fill"></i>
                                </button>
                                <button 
                                  className="trending-category-action-buttons"
                                  onClick={() => handleDelete(trendingCategory._id)}
                                >
                                  <i className="ri-delete-bin-fill"></i>
                                </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default TrendingCategoryList;
